import { html } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../common/mixin';
export const dataTableTemplate = html `<template role="table"><slot></slot></template>`;
export class DataTableComponent extends ChameleonElementMixin(FoundationElement) {
}
